import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function ImportacaoPrivilegios({ user, permissions, setPermissions }) {
  return (
    <>
      <Header header={'Importação Normal'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoImportacaoAnalise'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Importação processo em Análise '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoImportacaoChefeArea'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Importação processo em Chefe de Área '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoImportacaoChefeDepartamento'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Importação processo em Chefe de Departamento '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoImportacaoDirectoraGeralAdjunta'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Importação processo em Directora Geral Adjunta '}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'solicitacaoImportacaoDirectorGeral'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Solicitação de Importação processo em Director Geral '}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />

    </>
  )
}
